  // js navbar scroll fixed system
function onscrollFunction() {
  if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
      document.querySelector('.start-header').classList.add('scroll-on');
  } else {
      document.querySelector('.start-header').classList.remove('scroll-on')
  }
}

$(function() {
    window.onscroll = function() {
      onscrollFunction();
    }

    // 首頁載入的進場動畫 : 瀏覽器僅顯示一次
    if (!sessionStorage.getItem('pageLoaded')) {
      var percent = 0;
      var timer = setInterval(function () {
        $(".bar").css("width", percent + "%");
        percent += 1;

        if (percent > 100) {
      clearInterval(timer);
      $(".pageloading").addClass("compelet");
      sessionStorage.setItem('pageLoaded', 'true');
        }
      }, 30);
    } else {
      $(".pageloading").remove();
    }

    // 以下為 Cookies 記錄在當前瀏覽器僅顯示一次
      if(!sessionStorage.getItem("agreeterm")){
        $('.cookies').stop(true).addClass('display');
      }

      $(".close-cookies").on('click',function(e) {
        e.preventDefault();
        sessionStorage.setItem("agreeterm", true);
        $(".cookies").addClass("close-cookies");
      });
    // End

    // js-mobile-btn
      $('.list-group-mobile-btn').on('click',function(){
        $('.list-group-mobile-wrap').toggleClass('d-none');
        return false;
      })
  
    // 以下為Gotop
      $(".float-link .link-btn.top, .float-link .link-btn.mobile-top").on('click',function () {
        $("html,body").animate({ "scrollTop": "0" })
      });
  
      $(window).on("load resize scroll", function (e) {
        var scroll = $(this).scrollTop();
        var wdh = $(window).height();
        if (scroll > 50) {
            $(".float-link").addClass("active");
        } else {
            $(".float-link").removeClass("active");
        }
      });

    // BS navbar-collapse show / hidden
      $('.navbar-toggler').on('click',function(){
        $('.navbar-overlay, .navbar-toggler.fixed').addClass('active')
      });
 
      $('#js-navbarToggle-fixed').on('click', function () {
        $('#navbar-content').removeClass('show');
        $('.navbar-overlay, .navbar-toggler.fixed').removeClass('active')
      });
    
    // Swiper

      // 共用Auto 
      var auplayFun = {
        delay: 3500,
        //stopOnLastSlide: false,
        disableOnInteraction: false,
      }
      
      // 首頁 - Banner
      if ($('.fancy-slider').length > 0) {
        var indexBannerSwiper = new Swiper('.fancy-slider .swiper', {
          speed: 1000,
          effect: "fade",
          fadeEffect: {
            crossFade: true
          },
          // effect: 'cube',
          loop: true,//必须
          autoplay: auplayFun,
          autoHeight: true, //高度随内容变化
          navigation: {
            nextEl: '.fancy-slider .fancy-slider-button-next',
            prevEl: '.fancy-slider .fancy-slider-button-prev',
          },
          pagination: {
            el: '.fancy-slider .swiper-pagination',
            clickable :true,
          }
        });
      }

      // 首頁-精選案例
      if ($('.index-pageCase-swiper .mySwiper').length > 0) {
        var indexCase_swiper = new Swiper(".index-pageCase-swiper .mySwiper", {
          loop:true,
          autoplay: auplayFun,
          speed:1000,
          slidesPerView: 5,
          spaceBetween: 5,
          // navigation: {
          //   nextEl: ".index-pageCase-swiper .swiper-button-next",
          //   prevEl: ".index-pageCase-swiper .swiper-button-prev",
          // },
          breakpoints: { 
            320: {  //当屏幕宽度大于等于320
              slidesPerView: 1,
              spaceBetween: 5
            },
            768: {  //当屏幕宽度大于等于768 
              slidesPerView: 3,
              spaceBetween: 10
            },
            1280: {  //当屏幕宽度大于等于1280
              slidesPerView: 5,
              spaceBetween: 5,
            }
          }
        });
      }

      // 產品詳細
      // 小圖
      var Prod_mySwiper = new Swiper(".Prod-conInfo-img .Prod_mySwiper", {
        // autoplay: auplayFun,
        autoplay:auplayFun,
        speed: 1000,
        freeMode: true,
        grabCursor : true,
        direction: 'vertical',
        breakpoints: { 
          320: {  //当屏幕宽度大于等于320
            slidesPerView: 3,
            spaceBetween: 5,
            direction: 'horizontal',
          },
          768: {  //当屏幕宽度大于等于768
            slidesPerView: 3,
            spaceBetween: 5,
            direction: 'horizontal',
          },
          1200: {  //当屏幕宽度大于等于1200
            slidesPerView: 4,
            spaceBetween: 5,
            direction: 'vertical',
          },
          1280: {  //当屏幕宽度大于等于1280
            slidesPerView: 4,
            spaceBetween: 10,
            direction: 'vertical',
          },
          1600: {  //当屏幕宽度大于等于1600
            slidesPerView: 4,
            spaceBetween: 5,
            direction: 'vertical',
          }
        }
      });

      // 大圖
      var Prod_mySwiper2 = new Swiper(".Prod-conInfo-img .Prod_mySwiper2", {
        // autoplay: auplayFun,
        autoplay:auplayFun,
        speed: 1000,
        spaceBetween: 10,
        navigation: {
          nextEl: ".Prod-conInfo-img .swiper-button-next",
          prevEl: ".Prod-conInfo-img .swiper-button-prev",
        },
        
        thumbs: {
          swiper: Prod_mySwiper,
        },

        breakpoints: { 
          320: {  //当屏幕宽度大于等于320
            spaceBetween: 0,
          },
          760: {  //当屏幕宽度大于等于760
            spaceBetween: 10,
          },
          1280: {
            direction: 'vertical',
          }
        }
      });
    // 產品詳細End

 });
